module.exports = __webpack_public_path__ + "img/shot-0.775883dd.png";